import styled from 'styled-components';

const Wrapper = styled.div`
  width: ${(props) => (props.$inline ? `${props.$size}px` : 'auto')};
  height: ${(props) => (props.$inline ? `${props.$size}px` : 'auto')};

  #loader-wrapper {
    pointer-events: none;
    position: ${(props) => (props.$inline ? 'relative' : 'fixed')};
    top: 0;
    left: 0;
    width: ${(props) => (props.$inline ? `${props.$size}px` : '100%')};
    height: ${(props) => (props.$inline ? `${props.$size}px` : '100%')};
    z-index: 100;
    background: ${(props) => (props.$inline ? 'transparent' : 'rgba(10, 10, 10, 0.52)')};
  }
  #loader {
    display: block;
    position: relative;
    left: ${(props) => (props.$inline ? 0 : '50%')};
    top: ${(props) => (props.$inline ? 0 : '50%')};
    width: ${(props) => (props.$inline ? `${props.$size}px` : '75px')};
    height: ${(props) => (props.$inline ? `${props.$size}px` : '75px')};
    margin: ${(props) => (props.$inline ? 0 : '-25px 0 0 -25px')};
    border-radius: 50%;
    border: ${(props) => (props.$inline ? '2px' : '3px')} solid rgba(82, 82, 82, 0.5);
    border-top-color: #c8a63a;
    -webkit-animation: spin 2s linear infinite; /* Chrome, Opera 15+, Safari 5+ */
    animation: spin 2s linear infinite; /* Chrome, Firefox 16+, IE 10+, Opera */
    box-shadow: 0 0 10px rgba(200, 166, 58, 0.22);
  }

  #loader:before {
    content: '';
    position: absolute;
    top: ${(props) => (props.$inline ? '3px' : '5px')};
    left: ${(props) => (props.$inline ? '3px' : '5px')};
    right: ${(props) => (props.$inline ? '3px' : '5px')};
    bottom: ${(props) => (props.$inline ? '3px' : '5px')};
    border-radius: 50%;
    border: ${(props) => (props.$inline ? '2px' : '3px')} solid rgba(70, 70, 70, 0.5);
    border-top-color: #8a8a8a;
    -webkit-animation: spin 3s linear infinite; /* Chrome, Opera 15+, Safari 5+ */
    animation: spin 3s linear infinite; /* Chrome, Firefox 16+, IE 10+, Opera */
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);
  }

  #loader:after {
    content: '';
    position: absolute;
    top: ${(props) => (props.$inline ? '7px' : '15px')};
    left: ${(props) => (props.$inline ? '7px' : '15px')};
    right: ${(props) => (props.$inline ? '7px' : '15px')};
    bottom: ${(props) => (props.$inline ? '7px' : '15px')};
    border-radius: 50%;
    border: ${(props) => (props.$inline ? '2px' : '3px')} solid rgba(96, 96, 96, 0.24);
    border-top-color: #b89631;
    -webkit-animation: spin 1.5s linear infinite; /* Chrome, Opera 15+, Safari 5+ */
    animation: spin 1.5s linear infinite; /* Chrome, Firefox 16+, IE 10+, Opera */
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
  }

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg); /* Chrome, Opera 15+, Safari 3.1+ */
      -ms-transform: rotate(0deg); /* IE 9 */
      transform: rotate(0deg); /* Firefox 16+, IE 10+, Opera */
    }
    100% {
      -webkit-transform: rotate(360deg); /* Chrome, Opera 15+, Safari 3.1+ */
      -ms-transform: rotate(360deg); /* IE 9 */
      transform: rotate(360deg); /* Firefox 16+, IE 10+, Opera */
    }
  }
  @keyframes spin {
    0% {
      -webkit-transform: rotate(0deg); /* Chrome, Opera 15+, Safari 3.1+ */
      -ms-transform: rotate(0deg); /* IE 9 */
      transform: rotate(0deg); /* Firefox 16+, IE 10+, Opera */
    }
    100% {
      -webkit-transform: rotate(360deg); /* Chrome, Opera 15+, Safari 3.1+ */
      -ms-transform: rotate(360deg); /* IE 9 */
      transform: rotate(360deg); /* Firefox 16+, IE 10+, Opera */
    }
  }
`;

export default Wrapper;
